import type { AccountType } from '@budget/shared';

/**
 * Pictogrammes proposés à la création d'un compte ou d'un pôle.
 *
 * Volontairement une liste courte et concrète : un choix trop vaste fait
 * hésiter sans rien apporter. Elle couvre les motifs d'épargne courants d'un
 * foyer et les formes de comptes françaises.
 */
export const GLYPH_CHOICES = [
  '🏦',
  '💳',
  '👛',
  '💶',
  '🐷',
  '📗',
  '🔒',
  '📈',
  '🏠',
  '🛠️',
  '🚗',
  '🚲',
  '✈️',
  '🏖️',
  '⛺',
  '🎿',
  '🎓',
  '👶',
  '🧸',
  '🐕',
  '💍',
  '🎁',
  '🎄',
  '🩺',
  '💻',
  '📱',
  '🛋️',
  '🎸',
  '🍽️',
  '🎯',
  '🚨',
  '💰',
] as const;

/** Glyphe par défaut d'un compte, quand aucun n'a été choisi. */
export function accountGlyph(account: { icon?: string; type: AccountType }): string {
  if (account.icon !== undefined && account.icon !== '') return account.icon;
  return account.type === 'savings' ? '🏦' : '💳';
}

/** Glyphe par défaut d'un pôle : une cible, faute de mieux. */
export function goalGlyph(goal: { icon: string }): string {
  return goal.icon !== '' ? goal.icon : '🎯';
}
